import React, {useCallback} from 'react';
import {
  useDropOrderItem,
  useIsEligibleForAdjacentOOS,
} from '../../../../itemDetails/hooks/ItemDetails';

import AppModal from '../../../../common/components/CustomModal/AppModal';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {StyleSheet} from 'react-native';
import font from '../../../../appStyles/style/font';
import {useColorThemeType} from '../../../../appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';
import {useSubstituteItemDetailsContext} from '@buncha/itemDetails/hooks/SubstituteItemDetail';

interface ModalBodyProps {
  onClose: any;
  orderItemId: number;
  open: boolean;
  handleAdjacentItemFound?: () => void;
  navigateToBatchDetail: () => void;
}

const DropAdjacentItemModalBody = (props: ModalBodyProps) => {
  const theme = useColorThemeType('main');
  const {dropOrderItem, droppingItem} = useDropOrderItem();
  const {checkAdjacentOOS} = useIsEligibleForAdjacentOOS();
  const {state} = useSubstituteItemDetailsContext();
  const {title, button} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};

  const dropItem = useCallback(async () => {
    const res = await checkAdjacentOOS({
      runId: state?.runId,
      orderId: state?.newOrderId,
      orderItemId: props?.orderItemId,
      catalogItemId: state.item?.catalogItemId || 0,
    });
    if (!res?.isEligible && state?.runId)
      await dropOrderItem(state?.runId, [props?.orderItemId], true);
    props?.navigateToBatchDetail();
    props?.onClose();
  }, [
    checkAdjacentOOS,
    dropOrderItem,
    props,
    state.item?.catalogItemId,
    state?.newOrderId,
    state?.runId,
  ]);

  return (
    <AppModal
      isOpen={props?.open}
      onClose={() => props?.onClose()}
      topCTAHandelr={dropItem}
      bottomCTAHandelr={props?.handleAdjacentItemFound}
      hideBottomCta={false}
      title={title?.availabilityChecked}
      titleStyle={styles.headerTypo}
      ctaBottomTitle={button?.foundItem}
      ctaTopTitle={button?.notAvailable}
      topCTAColor={theme?.background.blue[100]}
      loading={droppingItem}
      topCTAFontSize={font.FontSize.fontH5.fontSize}
    />
  );
};

export default React.memo(DropAdjacentItemModalBody);

const styles = StyleSheet.create({
  headerTypo: {
    fontFamily: font.fonts['Mortise-Bold'],
    ...font.FontSize.fontH2,
  },
});
